// Configuration centralisée des logos pour chaque établissement

export const LOGOS = {
  // Logo pour le portail principal (Fred et Poppée)
  portail: 'https://res.cloudinary.com/dzc0bh0kf/image/upload/v1789884834/logos-04-removebg-preview_1_oaqekl_eiaeau.png',
  
  // Logo pour l'Institut
  // institut: 'https://res.cloudinary.com/dsgd2h3dx/image/upload/v1765566493/logos-04-removebg-preview_1_oaqekl.png',
  institut:'https://res.cloudinary.com/dxbfpabjs/image/upload/v1770379848/FRED_POPP%C3%89E_-_LOGO-distinct-02_f7kl9b.png',
  // Logo pour le Lycée Français
  lyceeFrancais: 'https://res.cloudinary.com/dzc0bh0kf/image/upload/v1789884217/logos-03-removebg-preview_2_qfsiid_zoftyr.png',
  
  // Logo pour le Lycée Ivoirien
  lyceeIvoirien: 'https://res.cloudinary.com/dzc0bh0kf/image/upload/v1789884231/logos_Plan_de_travail_1-removebg-preview_3_u2azjh_ws4qio.png',
  
  // Logo pour Maternelle & Primaire
  maternellePrimaire: 'https://res.cloudinary.com/dzc0bh0kf/image/upload/v1789884197/logos-02-removebg-preview_2_geenzj_jkkhkj.png',
};

// Fonction utilitaire pour obtenir le logo selon l'établissement
export const getLogoByEtablissement = (etablissement: string): string => {
  switch (etablissement) {
    case 'lycee-francais':
      return LOGOS.lyceeFrancais;
    case 'lycee-ivoirien':
      return LOGOS.lyceeIvoirien;
    case 'maternelle-primaire':
      return LOGOS.maternellePrimaire;
    case 'institut':
      return LOGOS.institut;
    default:
      return LOGOS.portail;
  }
};
